export namespace APIS {
  export const LOGIN: string = "/auth/authenticate";

  //Fee dues APIs
  export const FEE_DUE_DATA_FOR_GRADE_NAME_AND_SECTION_NAME_AND_TERMs: string =
    "/feeDue/grade/gradeName_value/section/section_value/terms/terms_value";
  export const FEE_DUE_DATA_FOR_TERM: string = "/fee/due/term/term_value";
  export const FEE_DUE_DATA_FOR_STUDENT_BY_ADMISSION_NO: string = "/feeDue/student";

  export const FEE_DUE_REPORTS_FOR_STUDENT: string = "/fee/due/reports/student/";

  //Grade APIs
  export const GRADES: string = "/grades";
  export const UPDATE_GRADES: string = "/grades";

  export const SECTIONS: string = "/sections";

  //USER APIs
  // STUDENT APIs
  export const STUDENTS: string = "/students";
  export const STUDENT_PERSON: string = "/students/person";
  export const ACTIVATE_STUDENT: string = "/students/activate/";
  export const PUBLIC_ADMISSION_STUDENT: string = "/public/admission/student";

  export const GET_STUDENTS_FOR_ADMISSION_NO: string = "/students/admissionNo/";
  export const GET_STUDENTS_FOR_GRADE_AND_SECTION = "/students/grade/grade_value/section/section_value";
  export const PROMOTE_STUDENTS = "/promote";

  export const PAY_STUDENT_FEE: string = "/fee/pay";
  export const FEE_RECEIPT_PDF: string = "/fee/receipts/receipt_no/pdf";
  export const FEE_RECEIPT: string = "/fee/receipts/receipt_no";

  //attendances
  export const ATTENDANCES: string = "/attendances";
  export const GET_STUDENTS_FOR_ATTENDANCE_BY_GRADE_AND_SECTION = "/attendances/grade/grade_value/section/section_value";

  //Messages
  export const FEE_DUE_REMINDER_MESSAGES: string = "/messages/feeDueAlerts";

  //Enquiry
  export const PUBLIC_ENQUIRIES: string = "/public/enquiries";
  export const GET_ENQUIRIES_BY_GRADE_AND_STATE: string = "/enquiries/state_value";
  export const ENQUIRIES: string = "/enquiries";
  export const ENQUIRIES_SEARCH: string = "/enquiries/search";

  //Admissions
  export const VERIFY_ADMISSION: string = "/public/admission/verify";

  //System Settings
  export const SYSTEM_SETTINGS: string = "/admin/settings";
}

export namespace PUBLIC_APIS {
  export const FIND_LOGIN_ID = "/public/users/guardianMobile/guardian_mobile";
}
export namespace STUDENT_APIS {
  export const STUDENTS = "/students";
  export const BY_ADMISSION_NO = "/students/admissionNo";
  export const PRINT_STUDENT_ADMISSION_FORM = "/students/printAdmissionForm";
  export const GET_STUDENTS_BY_GRADE_AND_SECTION_AND_STATUS: string = "/students/grade/grade_value/section/section_value/status/status_val";
  export const GET_IN_ACTIVE_STUDENTS_BY_GRADE: string = "/students/grade/grade_value/status/status_val";
  export const PARENTS_AND_GUARDIAN: string = "/students/persons";
  export const DEACTIVATE_STUDENT: string = "/students/deactivate";
  export const GET_ALL_STUDENTS_FOR_GRADE_AND_SECTION = "/students/all/grade/grade_value/section/section_value";
  export const TOTAL_SUMMARY: string = "/students/total-summary";
}

export namespace USER_APIS {
  export const USERS = "/users";
  export const USERS_TYPE = "/users/type/user_type";
  export const UPDATE_PASSWORD = "/users/updatePassword";
  export const RESET_PASSWORD = "/users/loginId_value/password/reset";
}

export namespace ENQUIRY_APIS {
  export const GET_ENQUIRIES_BY_STATE = "/students/state_value";
}

export namespace FEE_APIS {
  export const GET_FEE_LIST_BY_STUDENTS: string = "/fee/list/byStudent";
  // GET /fee?view=xl|list&grade=&section=&date1=&date2=[&page=&size=]
  export const GET_FEE_RECEIPTS: string = "/fee";
}

export namespace FEE_DUE_APIS {
  export const FEE_DUE = "/feeDue";
  export const GET_FD_BY_GRADE_AND_SECTION_AND_TERMS_AND_STATUS: string =
    "/feeDue/grade/gradeName_value/section/section_value/terms/terms_value/status/status_value";
  export const GET_PREVIOUS_YEAR_DUES: string = "/students/previous-year-dues";
  export const CANCEL: string = "/feeDue/cancel";
}

export namespace PAYMENT_APIS {
  export const INITIATE_PAYMENT: string = "/payments/initiate";
  export const GET_PAYMENT_WEB_LINK_FOR_PO_ID: string = "/payments/poId_value/webLink";
  export const GET_PAYMENT_HISTORY: string = "/payments/history";
}

export namespace SMS_APIS {
  export const HOLIDAY: string = "/messages/holiday";
}

export namespace DASHBOARD_APIS {
  export const GET_DASHBOARD: string = "/dashboard";
  export const GET_FACULTY_DASHBOARD: string = "/dashboard/faculty";
  export const GET_STUDENT_DASHBOARD: string = "/dashboard/student";
}

export namespace PERSON_APIS {
  export const PERSONS: string = "/persons";
  export const GET_BY_AADHAAR_NO: string = "/public/persons/aadhaarNumber/aadhaarNumber_value";
  export const GET_BY_MOBILE_NO: string = "/public/persons/mobileNumber/mobile_value";
}
